jQuery(document).ready(function() {
    var $ = jQuery; 
    let starBtns = $(".sc-star-rating > button");
    const scRatingRow = $(".sc-rating-row");
    const scReviewForm = $("#scRatingForm");
    const trustPilotBtns = $("#trustPilotBtns");
    const scReviewTitle = $("#scReviewModalLabel");
    const reviewThankYou = $("#reviewThankYou");
    var rating = 0;

    $('#scReviewModal').modal('show');

    $(starBtns).on('click', function(e){
        let star = e.currentTarget;
        let parent = star.parentNode;
        // The equivalent of parent.children.indexOf(child)
        rating = Array.prototype.indexOf.call(parent.children, star) + 1;

        $('input[name="scrating"]').val(rating);
        $(star).parent().children().each( function(idx, elem) {
            if(idx < rating)
            {
                $(elem).addClass('full').removeClass('empty');
            }
            else
            {
                $(elem).removeClass('full').addClass('empty');
            }
        });

        if ($(star).hasClass('open-form')) {
            if (scReviewTitle.text() == 'Share your experience with others?') {
                scReviewTitle.fadeOut(function() {
                    $(this).text("How would you rate SnackCrate?")
                  }).fadeIn();
            }
            trustPilotBtns.slideUp();
            scReviewForm.slideDown();
        }

        if ($(star).hasClass('trust-pilot')) {
            if (scReviewTitle.text() == 'How would you rate SnackCrate?') {
                scReviewTitle.fadeOut(function() {
                    $(this).text("Share your experience with others?")
                  }).fadeIn();
            }
            scReviewForm.slideUp();
            trustPilotBtns.slideDown();
        }
    });

    scReviewForm.on('submit', function(e) {
        scRatingRow.slideUp();
        scReviewForm.slideUp();
        scReviewTitle.fadeOut(function() {
            $(this).text("Thanks for sharing your experience!")
          }).fadeIn();
        reviewThankYou.slideDown();
    });

    // CODE FROM OLD SNACKCRATE ACCOUNT MODAL

    // var starRating = null;
    // var formSubmitted = false;

    // function setRating(thisObj) {
    //     var newRating = 0;

    //     $(thisObj).children("li.star").each(function(i, star) {
    //         $(star).children("i").hasClass("fas") && newRating++;
    //     })

    //     starRating = newRating;
    // }

    // SUBMITS FEEDBACK IF USER CLICKS ONE OF THE TRUST-PILOT-BTNS
    // $(".rating-accept").on("click", function() { 
	//     submitFeedback(5, null);
	//     formSubmitted = true; 
	// });
	
	// $(".rating-deny").on("click", function() { 
	//     submitFeedback(5, null);
	//     formSubmitted = true; 
	// });

    // function handleFormSubmit(e, thisObj) {
    //     e.preventDefault();

    //     var feedback = $(thisObj).parent().children("textarea").val();

    //     if (feedback.length) {
    //         submitFeedback(starRating, feedback);
    //         thankYou();
    //         formSubmitted = true;
    //     }
    //     else {
    //         toggleWarning();
    //     }
    // }

    // function submitFeedback(rating, feedback) {
    //     // THIS DATA NEEDS TO BE POSTED TO A DATABASE 
    //     //  - rating   : int [1-5]
    //     //  - feedback : string
    //     options = {
	//         'do':'submitFeedback',
	//         'feedback':feedback,
	//         'rating':rating
    //     };
        
    //     $.ajax({
    //     	url: "<?php echo get_template_directory_uri(); ?>/assets/includes/accountAjax.php",
    //     	type: "POST",
    //     	data: options,
    //     	dataType: "json",
    //     	success: function(returnVal) {
    //     		console.log(returnVal);
    //     	},
    //     	error: function (evt) {
    //     		console.log(evt);
    //     	}
    //     });
        
        
    // }

    // function setDelay() {
    //     // THIS SHOULD TRIGGER A TIMER TO POP MODAL UP AFTER 7 DAYS
    //     submitFeedback(0, null);
    // }
});